import Breadcrumb from '../Components/Breadcrumb';
import SEO from '../Components/SEO';

export default function TermsOfService() {
    return (
        <div>
            <SEO
                title='Terms of Service | English Exam Exercises'
                description='Terms and conditions for using English Exam Exercises website and services.'
                name='English Exam Exercises'
                type='article' />
            <Breadcrumb />

            <div className="grammar-container">
                <div className="exercises-container div1">
                    <div className='homebodytext'>
                        <img src="/Images/terms-of-service.webp" alt="Terms of Service" />
                        <section>
                            <h2>Terms of Service</h2>
                            <p><strong>Last updated:</strong> September 20, 2026</p>

                            <h3>1. Acceptance of Terms</h3>
                            <p>By accessing and using English Exam Exercises (<strong>the "Site"</strong>), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Site.</p>

                            <h3>2. Use of Content</h3>
                            <p>All exercises, explanations, vocabulary lists, and other educational materials on this Site (<strong>"Content"</strong>) are provided for personal, non-commercial educational purposes only. You may:</p>
                            <ul>
                                <li>Access and use the Content for your own learning</li>
                                <li>Print individual exercises for personal study</li>
                                <li>Share links to the Site with others</li>
                            </ul>
                            <p>You may <strong>not</strong>:</p>
                            <ul>
                                <li>Republish, sell, or distribute the Content commercially</li>
                                <li>Remove copyright notices from any materials</li>
                                <li>Use automated tools to scrape or download Content in bulk</li>
                                <li>Frame the Site or present Content as your own</li>
                            </ul>

                            <h3>3. User Conduct</h3>
                            <p>You agree not to:</p>
                            <ul>
                                <li>Use the Site for any unlawful purpose</li>
                                <li>Interfere with the Site's security or functionality</li>
                                <li>Post spam, malware, or harmful content</li>
                                <li>Impersonate any person or entity</li>
                            </ul>

                            <h3>4. Intellectual Property</h3>
                            <p>All Content, design, logos, and code are the property of English Exam Exercises or its licensors. Nothing in these Terms transfers ownership of any intellectual property to you.</p>

                            <h3>5. Third-Party Links and Ads</h3>
                            <p>The Site contains links to third-party websites and displays advertisements via Google AdSense. We are not responsible for the content, privacy practices, or accuracy of third-party sites. Your interactions with advertisers are solely between you and the advertiser.</p>

                            <h3>6. Disclaimers</h3>
                            <p>The Site and Content are provided <strong>"as is"</strong> without warranties of any kind. We do not guarantee that:</p>
                            <ul>
                                <li>The Site will be uninterrupted or error-free</li>
                                <li>Content is suitable for any specific exam or curriculum</li>
                                <li>Results from using the Site will improve exam scores</li>
                            </ul>

                            <h3>7. Limitation of Liability</h3>
                            <p>To the maximum extent permitted by law, English Exam Exercises shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Site.</p>

                            <h3>8. Changes to Terms</h3>
                            <p>We may modify these Terms at any time. Continued use of the Site after changes constitutes acceptance of the new Terms.</p>

                            <h3>9. Governing Law</h3>
                            <p>These Terms are governed by the laws of the jurisdiction where English Exam Exercises operates, without regard to conflict of law principles.</p>

                            <h3>10. Contact Us</h3>
                            <p>For questions about these Terms, visit our <a href="/contact">Contact page</a>.</p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}